import { queryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { workspaceService } from '@/services/database';
import { WorkspaceDataRetentionPolicyInput } from '@/types';

export const workspaceDataRetentionQueryKey = (workspaceId?: string) =>
    ['workspace', workspaceId ?? 'unavailable', 'data-retention'] as const;

export const workspaceDataRetentionQueryOptions = (workspaceId?: string, enabled = true) =>
    queryOptions({
        enabled: enabled && Boolean(workspaceId),
        queryFn: () => {
            if (!workspaceId) {
                throw new Error('A workspace is required to load data retention settings.');
            }

            return workspaceService.getDataRetentionPolicy(workspaceId);
        },
        queryKey: workspaceDataRetentionQueryKey(workspaceId),
        staleTime: 30_000,
    });

export const useUpdateWorkspaceDataRetention = (workspaceId?: string) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (input: WorkspaceDataRetentionPolicyInput) => {
            if (!workspaceId) {
                throw new Error('A workspace is required to update data retention settings.');
            }

            return workspaceService.updateDataRetentionPolicy(workspaceId, input);
        },
        onSuccess: (policy) => {
            queryClient.setQueryData(workspaceDataRetentionQueryKey(workspaceId), policy);
        },
    });
};
